import { useSvgParsedStyle } from '@/_shared/hooks/useSvgParsedStyle';
import { SvgProps } from '@/_shared/types/svg';

export const Bookmark = ({ style }: SvgProps) => {
  const { primaryColorToUse, heightToUse, widthToUse } = useSvgParsedStyle({
    defaultWidth: '25',
    defaultHeight: '25',
    style,
  });

  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={widthToUse}
      height={heightToUse}
      fill='none'
      viewBox='0 0 12 16'
    >
      <path
        d='M10.875 0.875H0.875V14.875L5.875 11.375L10.875 14.875V0.875Z'
        fill={primaryColorToUse}
        stroke={primaryColorToUse}
        strokeWidth='1.75'
        strokeLinejoin='round'
      />
    </svg>
  );
};
